<template lang="pug">
#RechazarCotizacion
  b-button(
    variant="action"
    @click="openModal"
  )
    | Rechazar Cotización
  //- Modal para confirmar rechazo
  b-modal.hide-footer(v-model="showModal" no-close-on-backdrop, title="Rechazar cotización", size="mg")
    h5.center ¿Que deseas hacer con la Oportunidad de Venta?
    b-button.btn-rechazar-option(
      size='md'
      variant='primary'
      @click='rechazarCotizacion("create_ov")'
      :disabled="loading"
    ) Rechazar y Preparar nueva OV
      b-spinner(v-if="loading" small)
    b-button.btn-rechazar-option(
      size='md'
      variant='danger'
      @click='rechazarCotizacion("close_ov")'
      :disabled="loading"
    ) Rechazar
      b-spinner(v-if="loading" small)
    template(#modal-footer='{ cancel }')
      b-button(size='sm' variant='secondary' @click='cancel' :disabled="loading") Cancelar

</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'RechazarCotizacion',
  data() {
    return {
      showModal: false,
      loading: false,
    }
  },
  props: {
    dataOv: {
      type: Object,
      required: true,
    },

  },
  methods: {
    ...mapActions('OVStore', ['declineOv']),
    async rechazarCotizacion(type) {
      this.loading = true
      try {
        const response = await this.declineOv({ id_oportunidad_venta: this.dataOv?.id, type })
        if(type === 'create_ov') {
            this.$bvToast.toast('Se ha creado la OV a partir de la Oportunidad rechazada ', {
            variant: 'warning',
            title: 'OV Creada',
            autoHideDelay: 5000,
          })
          const newOvId = response?.data?.new_ov_id
          if (newOvId) {
            this.hideModal()
            this.$router.push({ path: `/oportunidad-venta/${newOvId}` })
            return
          }
        } else {
          this.$bvToast.toast('OV Rechazada', {
            variant: 'danger',
            title: 'OV Rechazada',
            autoHideDelay: 5000,
          })
        }
      } catch (error) {
        this.$bvToast.toast('Error al rechazar la OV', {
          variant: 'danger',
          title: 'OV Rechazada',
          autoHideDelay: 5000,
        })
      } finally {
        this.loading = false
        this.$emit('reloadAll')
        this.hideModal()
      }
    },
    openModal() {
      this.showModal = true
    },
    hideModal() {
      this.showModal = false
    },
  },
}
</script>
<style lang="scss" scoped>
.center {
  text-align: center;
  width: 100%;
}
.btn-rechazar-option {
  width: 45%;
  height: 60px;
  margin-left: 15px;
  margin-top: 20px;
}
</style>
